import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { PoreskoOslobodjenje } from './poresko-oslobodjenje';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-poresko-oslobodjenje',
  templateUrl: './poresko-oslobodjenje.component.html'
})
export class PoreskoOslobodjenjeComponent extends BaseModalContainer<PoreskoOslobodjenje> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<PoreskoOslobodjenje>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
